import React, { useContext, useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { GOOGLE_LOGIN_CLIENT_ID, IS_LOCAL } from '../Constants/URLs';
import { Button, message, Spin } from 'antd';
import { postAPI } from '../Services/Api';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../Stores/AuthContext';

const MOCK_USER = {
  sub: 'local-mock-user',
  email: process.env.REACT_APP_MOCK_USER_EMAIL || 'local.user@attentive.ai'
};

const Login = () => {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const onLoginSuccess = userObj => {
    let obj = {
      id: userObj.sub,
      email: userObj.email
    };
    sessionStorage.setItem('user', JSON.stringify(obj));
    setIsAuthenticated(true);

    if (location.state?.from) {
      window.location.replace(location.state.from);
    } else {
      window.location.replace('/');
    }
  };

  // local: skip Google and the backend /login call
  const handleMockLogin = () => onLoginSuccess(MOCK_USER);

  const handleLoginCallback = res => {
    setIsLoading(true);

    let userObj = jwt_decode(res.credential);

    let payload = {
      email_id: userObj.email,
      unique_id: userObj.sub
    };
    postAPI('/login', payload)
      .then(res => onLoginSuccess(userObj))
      .catch(err => {
        setIsAuthenticated(false);
        message.error('Cannot log you in');
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (!isAuthenticated && !IS_LOCAL) {
      /* global google */
      google.accounts.id.initialize({
        client_id: GOOGLE_LOGIN_CLIENT_ID,
        callback: handleLoginCallback
      });

      google.accounts.id.renderButton(document.getElementById('signInDiv'), {
        theme: 'outline',
        size: 'large'
      });
    }

    // eslint-disable-next-line
  }, []);

  if (isAuthenticated) {
    return <Navigate to={location?.state?.from ?? '/'} />;
  }

  return (
    <>
      <Spin spinning={isLoading}>
        {IS_LOCAL ? (
          <div className='google_login_btn'>
            <Button type='primary' size='large' onClick={handleMockLogin}>
              Sign in as {MOCK_USER.email} (local)
            </Button>
          </div>
        ) : (
          <div id='signInDiv' className='google_login_btn'></div>
        )}
      </Spin>
    </>
  );
};

export default Login;
